// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__js8Dz","type":"styles_type__1OLZF","choices":"styles_choices__aKQhL"};